import { render, staticRenderFns } from "./addCategory.vue?vue&type=template&id=7ebfd077&scoped=true"
import script from "./addCategory.vue?vue&type=script&lang=js"
export * from "./addCategory.vue?vue&type=script&lang=js"
import style0 from "./addCategory.vue?vue&type=style&index=0&id=7ebfd077&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebfd077",
  null
  
)

export default component.exports